// booleanCheck function receives boolean 
// returns string 
export const booleanCheck = (n: boolean) => n !== false ? 'true' : 'false'


